import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigurationState } from 'remarketing-angular-library';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { Store } from '@ngxs/store';
import {
  FormatPhoneNumberPipe,
  SaComponent,
  TelephoneLinkPipe
} from 'smartauction-frontend-micro-library';
import { TranslocoDirective } from '@jsverse/transloco';


@Component({
    selector: 'provincial-restriction-error-modal',
    templateUrl: './province-error-modal.component.html',
    styleUrls: ['./province-error-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, FormatPhoneNumberPipe, TelephoneLinkPipe]
})
export class ProvinceErrorModalComponent extends SaComponent implements OnInit {
  @ViewChild(ModalComponent) modal: ModalComponent;
  tenantPhoneNumber: string;

  constructor(private readonly store: Store) {
    super();
  }

  ngOnInit(): void {
    this.tenantPhoneNumber = this.store.selectSnapshot(ConfigurationState.configuration).header.contactInfo.phoneNumber;
  }

  show() {
    this.modal.show();
  }

  close() {
    this.modal.close();
  }
}
